import { Input, Select } from '@chakra-ui/react';

const ShippingInformation = ({
  register,
  carrierList,
  errors,
  canEditTracking,
}) => {
  const trackingError =
    errors.courierUUID ?? errors.trackingUrl ?? errors.trackingCode;

  return (
    <div className="row d-flex align-items-center my-2">
      <div className="col-12 col-md-4">
        <p className="fw-bold mb-0 ">Informações de rastreio (*)</p>
        {trackingError && (
          <p className="text-danger">{trackingError?.message}</p>
        )}
      </div>

      <div className="col-12 col-md-2">
        <Select
          aria-label="Selecione a transportadora"
          {...register('courierUUID', { required: true })}
          data-testid="shipping-company-uuid"
          disabled={!canEditTracking}
          h="48px"
        >
          <option disabled>Transportadora</option>
          {carrierList.map(carrier => (
            <option key={carrier.uuid} value={carrier.uuid}>
              {carrier.alias}
            </option>
          ))}
        </Select>
      </div>
      <div className="col-12 col-md-4">
        <Input
          type="text"
          {...register('trackingUrl', {
            required: true,
          })}
          id="trackingUrl"
          disabled={!canEditTracking}
          placeholder="Link da página de rastreio"
          height="48px"
        />
      </div>
      <div className="col-12 col-md-2">
        <Input
          type="text"
          {...register('trackingCode')}
          disabled={!canEditTracking}
          placeholder="Código de rastreio"
          height="48px"
        />
      </div>
    </div>
  );
};

export default ShippingInformation;
